export const selectPDPDetails = state => state.productReducer || {};
